module.exports = __webpack_public_path__ + "static/media/default-avatar.711527a8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/default-avatar.svg
// module id = 889
// module chunks = 0